export const PALETTES_PER_ROW = 3;
